/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyDepartmentInfo,
    JsonCompanyDepartmentInfoFromJSON,
    JsonCompanyDepartmentInfoFromJSONTyped,
    JsonCompanyDepartmentInfoToJSON,
} from './JsonCompanyDepartmentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyDepartmentInfo
 */
export interface ApiResultOfListOfJsonCompanyDepartmentInfo {
    /**
     * 
     * @type {Array<JsonCompanyDepartmentInfo>}
     * @memberof ApiResultOfListOfJsonCompanyDepartmentInfo
     */
    data?: Array<JsonCompanyDepartmentInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDepartmentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyDepartmentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDepartmentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDepartmentInfo
     */
    result?: ApiResultOfListOfJsonCompanyDepartmentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyDepartmentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyDepartmentInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyDepartmentInfo {
    return ApiResultOfListOfJsonCompanyDepartmentInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyDepartmentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyDepartmentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyDepartmentInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyDepartmentInfoToJSON(value?: ApiResultOfListOfJsonCompanyDepartmentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyDepartmentInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

